import React from "react";
import { PageLayout } from "../components";

export default function Unauthorised() {
  return (
    <PageLayout>
      <PageLayout.Header title="Unauthorised" step={0} />
      <PageLayout.Content>
        <div className="ch-alert ch-alert--info ch-alert--icon ch-mb--2">
          We've lost connection to your valuation; please use the link we sent
          you on the device you plan to use.{" "}
        </div>
      </PageLayout.Content>
    </PageLayout>
  );
}
